<template>
	<li class="testimonials-box">
    <img :src="item.image" :alt="item.name" />
    <h4>{{ item.name }}</h4>
    <h6>{{ item.role }}</h6>
    <div class="text">
      <p v-html="item.text"></p>
      <div v-html="item.more"></div>
    </div>
	</li>
</template>

<script>
export default {
	name: 'TestimonialsContainerBox',
	props: {
		item: {
			type: Object,
			required: true,
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/sections/boxes/TestimonialsContainerBox.vue